// @flow

import React from 'react';

import { GoogleButton } from '@zapier/auth';
import { addParamsToUrl } from '@zapier/common-utils';

type Props = {
  /** True to make button blue */
  isBlue?: boolean,
  /** True to make button large */
  isLarge?: boolean,
  /** Button Text */
  label: string,
  /** $FlowFixMe - Called when button is clicked */
  onClick?: (e: SyntheticEvent<HTMLAnchorElement>, href: string) => any,
  /** Query params to be added to url */
  queryParams?: {},
};

const defaultProps = {
  label: 'Sign Up With Google',
  queryParams: {},
};

const GoogleSSOButton = (props: Props) => {
  const href = addParamsToUrl(
    '/google-sso/start',
    {
      scopes: 'basic',
      ...props.queryParams,
    },
    true
  );
  return (
    <GoogleButton
      href={href}
      isBlue={props.isBlue}
      isLarge={props.isLarge}
      label={props.label}
      onClick={e => props.onClick && props.onClick(e, href)}
    />
  );
};

GoogleSSOButton.defaultProps = defaultProps;

export default GoogleSSOButton;
